class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('#predictive-search-results');
    if (!this.input || !this.results) return;
    this.input.addEventListener('input', this.debounce(this.onChange.bind(this), 250));
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.results.classList.remove('is-active');
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  }

  escape(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  onChange() {
    const term = this.input.value.trim();
    if (!term.length) {
      this.results.innerHTML = '';
      this.results.classList.remove('is-active');
      return;
    }
    fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`)
      .then((res) => res.json())
      .then((data) => {
        const products = data.resources.results.products || [];
        if (!products.length) {
          this.results.innerHTML = `<div class="predictive-empty">No results for "${this.escape(term)}"</div>`;
        } else {
          this.results.innerHTML = `<ul class="predictive-list">${products.map((p) => {
            const img = p.featured_image && p.featured_image.url
              ? `<img src="${p.featured_image.url}" alt="" width="50" height="50">` : '';
            const price = parseFloat(p.price);
            return `<li><a href="${p.url}">${img}<div><strong>${this.escape(p.title)}</strong>
              <span>£${isNaN(price) ? p.price : price.toFixed(2)}</span></div></a></li>`;
          }).join('')}</ul>`;
        }
        this.results.classList.add('is-active');
      })
      .catch(() => this.results.classList.remove('is-active'));
  }
}
customElements.define('predictive-search', PredictiveSearch);
